import React, { useState, useEffect } from "react";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Blank from "../../../DefaultStyles/Blank";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { useApi } from "../../../../hooks/useApi";
import { IAlimTalk } from "../../../../pages/Message/AlimTalk";
import { getTemplateString } from "../../../pages/AlimTalk/AlimTalkTableData";
import DotStatus from "../../../DefaultStyles/DotStatus";
import LineBtn from "../../../Button/LineBtn";
import dayjs from "dayjs";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import Pagination from "../../../Table/Pagination";
import AlimTalkModal from "../../AlimTalk/AlimTalkModal";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";
import { GetSubscriptionSetData } from "../../../../ApiTS/ServiceDatasTS";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";
interface UserDetailAlimtalkProps {
  userId?: string;
}

export default function UserDetailAlimtalk({
  userId,
}: UserDetailAlimtalkProps) {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [talkId, setTalkId] = useState("");
  const [viewData, setViewData] = useState({
    user: "",
    template: "",
    sender: "",
    sendTime: "",
  });
  const [viewBtnClick, setViewBtnClick] = useState(false);
  const [talkData, setTalkData] = useState<string | undefined>("");
  const [checkSms, setCheckSms] = useState(false);
  const [smsStatus, setSmsStatus] = useState({
    talkId: "",
    status: "",
    index: 0,
  });
  const [status, setStatus] = useState({
    kakao: "",
    sms: "",
    api: "",
  });

  const { response, loading, error } = useApi({
    method: "get",
    url: userId ? `kakao?page=${page}&size=5&uid=${+userId}` : undefined,
  });

  // 알림톡 sms 상태 조회
  const { response: smsResponse, loading: smsLoading } = useApi({
    method: "post",
    url: checkSms ? `kakao/${smsStatus?.talkId}` : undefined,
  });

  const {
    response: viewResponse,
    loading: viewLoading,
    error: viewError,
  } = useApi({
    method: "get",
    url: viewBtnClick ? `kakao/${talkId}` : undefined,
  });

  const alimtalkInfoHeader = [
    "NO",
    "템플릿",
    "PID",
    "Subs_name",
    "알림톡",
    "SMS",
    "발송 일시",
    "조회",
  ];

  // 보낸 알림톡 상세 조회
  useEffect(() => {
    if (viewResponse?.status === 200) {
      setStatus({
        kakao: viewResponse?.data?.kakao_status,
        sms: viewResponse?.data?.sms_status,
        api: viewResponse?.data?.status,
      });

      setTalkData(viewResponse?.data?.message);
    }
  }, [viewResponse]);

  useEffect(() => {
    if (smsResponse?.status === 201) {
      if (smsResponse?.data?.result === "") {
        toast.success("확인 중입니다.");
      }

      setSmsStatus({
        ...smsStatus,
        status: smsResponse?.data?.result ?? "",
      });
      setCheckSms(false);
    }
  }, [smsResponse]);

  useEffect(() => {
    if (viewError) {
      toast.error(viewError?.data ?? "알림톡 조회에 실패했습니다.");
    }
  }, [viewError]);

  return (
    <>
      {response?.data?.items?.length > 0 && (
        <>
          <LineBox>
            <>
              <TitleWithLine title="알림톡" />

              <Blank blankHeight={24} />

              <Table tableHeadData={alimtalkInfoHeader}>
                <>
                  {response?.data?.items?.map((d: IAlimTalk) => (
                    <TableBody key={d.id}>
                      <TableBodyItem>{d?.id}</TableBodyItem>
                      <TableBodyItem>
                        {getTemplateString(Number(d?.template))}
                      </TableBodyItem>
                      <TableBodyItem
                        clickable={d?.partyid ? true : false}
                        onClick={() => {
                          if (d?.partyid) navigate(`/party/info/${d?.partyid}`);
                        }}
                      >
                        {d?.partyid ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem>
                        {d?.servsubsid
                          ? `${d?.servsubsid}_${getSubsNameBySubsId3(
                              d?.servsubsid ?? 0
                            )}`
                          : "-"}
                      </TableBodyItem>
                      <TableBodyItem>
                        <DotStatus
                          text={
                            200 <= Number(d?.status?.split("_")[1]) &&
                            Number(d?.status?.split("_")[1]) < 205
                              ? "성공"
                              : "실패"
                          }
                          color={
                            200 <= Number(d?.status?.split("_")[1]) &&
                            Number(d?.status?.split("_")[1]) < 205
                              ? "#00c7c7"
                              : "#f42d16"
                          }
                          size="sm"
                        />
                      </TableBodyItem>
                      <TableBodyItem>
                        {/* d?.status 이 성공이면 - 로 보여주기 */}
                        {200 <= Number(d?.status?.split("_")[1]) &&
                        Number(d?.status?.split("_")[1]) < 205 ? (
                          "-"
                        ) : d?.sms_status !== null ? (
                          <DotStatus
                            text={d?.sms_status === "-100" ? "성공" : "실패"}
                            color={
                              d?.sms_status === "-100" ? "#00c7c7" : "#f42d16"
                            }
                            size="sm"
                          />
                        ) : smsStatus?.status !== "" ? (
                          <DotStatus
                            text={
                              smsStatus?.status === "-100" ? "성공" : "실패"
                            }
                            color={
                              smsStatus?.status === "-100"
                                ? "#00c7c7"
                                : "#f42d16"
                            }
                            size="sm"
                          />
                        ) : (
                          <LineBtn
                            btnText="확인"
                            btnClickEvent={() => {
                              setSmsStatus((smsStatus) => ({
                                ...smsStatus,
                                talkId: d?.messageid ?? "",
                                index: smsStatus?.index + 1,
                              }));
                              setCheckSms(true);
                            }}
                          />
                        )}
                      </TableBodyItem>
                      <TableBodyItem>
                        {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm:ss")}
                      </TableBodyItem>
                      <TableBodyItem>
                        <LineBtn
                          btnText="조회"
                          btnClickEvent={() => {
                            setViewData({
                              user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                              template: `${d?.template}_${getTemplateString(
                                Number(d?.template)
                              )}`,
                              sender: d?.sender,
                              sendTime: d?.time,
                            });
                            setTalkId(d?.messageid);
                            setViewBtnClick(true);
                          }}
                          disabled={!auth?.kakao}
                        />
                      </TableBodyItem>
                    </TableBody>
                  ))}
                </>
              </Table>

              <Pagination
                totalPage={response?.data?.totalPage ?? 3}
                currentPage={page}
                pageClickEvent={(index) => setPage(index)}
              />
            </>
          </LineBox>

          <Blank blankHeight={20} />

          {(loading || smsLoading || viewLoading) && <Loader />}

          {/* 알림톡 조회 */}
          {viewBtnClick && talkData !== "" && (
            <AlimTalkModal
              closeEvent={() => {
                setViewBtnClick(false);
                setTalkData("");
                setViewData({
                  template: "",
                  user: "",
                  sender: "",
                  sendTime: "",
                });
              }}
              confirmEvent={() => setViewBtnClick(false)}
              talkData={talkData}
              viewData={viewData}
              status={status}
            />
          )}
        </>
      )}
    </>
  );
}
